"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastPlayerMobileTitle = void 0;
var React = require("react");
var PodcastPlayerMobileTitle = function (_a) {
    var title = _a.title, isRunning = _a.isRunning;
    return (React.createElement("div", { className: "podcast-player-mobile-title overflow-hidden whitespace-nowrap w-full relative" },
        React.createElement("div", { className: "podcast-player-mobile-title__container inline-block whitespace-nowrap ".concat(isRunning ? 'running animate-slide animation-running' : '') },
            React.createElement("span", { className: "pr-[50px]" }, title),
            React.createElement("span", null, title))));
};
exports.PodcastPlayerMobileTitle = PodcastPlayerMobileTitle;
